var _effectorFileName = "/src/features/quiz/quiz-context.tsx";
import React, { createContext, useContext } from 'react';
interface QuizContextType {
  onContactFormSubmit: () => void;
}
const QuizContext = createContext<QuizContextType | null>(null);
export const QuizProvider: React.FC<{
  children: React.ReactNode;
  onContactFormSubmit: () => void;
}> = ({
  children,
  onContactFormSubmit
}) => {
  return <QuizContext.Provider value={{
    onContactFormSubmit
  }}>{children}</QuizContext.Provider>;
};
export const useQuizContext = () => {
  const context = useContext(QuizContext);
  if (!context) {
    throw new Error('useQuizContext must be used within a QuizProvider');
  }
  return context;
};